export interface DailySnapshot {
  date: string;
  messages: number;
  tokens: number;
  inputTokens: number;
  outputTokens: number;
  total: number;
}

export const dailyHistory: DailySnapshot[] = [
  { date: "May 17", messages: 3, tokens: 4200, inputTokens: 2800, outputTokens: 1400, total: 17 },
  { date: "May 18", messages: 5, tokens: 6100, inputTokens: 4100, outputTokens: 2000, total: 26 },
  { date: "May 19", messages: 2, tokens: 3800, inputTokens: 2200, outputTokens: 1600, total: 15 },
  { date: "May 20", messages: 7, tokens: 8900, inputTokens: 6200, outputTokens: 2700, total: 37 },
  { date: "May 21", messages: 4, tokens: 5200, inputTokens: 3400, outputTokens: 1800, total: 22 },
  { date: "May 22", messages: 6, tokens: 7500, inputTokens: 5000, outputTokens: 2500, total: 32 },
  { date: "May 23", messages: 8, tokens: 10200, inputTokens: 7200, outputTokens: 3000, total: 42 },
  { date: "May 24", messages: 10, tokens: 12800, inputTokens: 9100, outputTokens: 3700, total: 53 },
  { date: "May 25", messages: 6, tokens: 8100, inputTokens: 5600, outputTokens: 2500, total: 33 },
  { date: "May 26", messages: 5, tokens: 6400, inputTokens: 4300, outputTokens: 2100, total: 27 },
  { date: "May 27", messages: 9, tokens: 11500, inputTokens: 8100, outputTokens: 3400, total: 48 },
  { date: "May 28", messages: 12, tokens: 15200, inputTokens: 10800, outputTokens: 4400, total: 63 },
  { date: "May 29", messages: 8, tokens: 10100, inputTokens: 7000, outputTokens: 3100, total: 42 },
  { date: "May 30", messages: 11, tokens: 13900, inputTokens: 9800, outputTokens: 4100, total: 58 },
  { date: "May 31", messages: 7, tokens: 9200, inputTokens: 6300, outputTokens: 2900, total: 38 },
  { date: "Jun 1", messages: 9, tokens: 11700, inputTokens: 8300, outputTokens: 3400, total: 48 },
  { date: "Jun 2", messages: 13, tokens: 16300, inputTokens: 11600, outputTokens: 4700, total: 68 },
  { date: "Jun 3", messages: 10, tokens: 12800, inputTokens: 8900, outputTokens: 3900, total: 53 },
  { date: "Jun 4", messages: 8, tokens: 10400, inputTokens: 7200, outputTokens: 3200, total: 43 },
  { date: "Jun 5", messages: 14, tokens: 17800, inputTokens: 12600, outputTokens: 5200, total: 74 },
  { date: "Jun 6", messages: 11, tokens: 14100, inputTokens: 9900, outputTokens: 4200, total: 58 },
  { date: "Jun 7", messages: 9, tokens: 11300, inputTokens: 7800, outputTokens: 3500, total: 47 },
  { date: "Jun 8", messages: 12, tokens: 15500, inputTokens: 10900, outputTokens: 4600, total: 64 },
  { date: "Jun 9", messages: 15, tokens: 18900, inputTokens: 13500, outputTokens: 5400, total: 78 },
  { date: "Jun 10", messages: 10, tokens: 13200, inputTokens: 9200, outputTokens: 4000, total: 54 },
  { date: "Jun 11", messages: 13, tokens: 16700, inputTokens: 11800, outputTokens: 4900, total: 69 },
  { date: "Jun 12", messages: 8, tokens: 10600, inputTokens: 7300, outputTokens: 3300, total: 44 },
  { date: "Jun 13", messages: 11, tokens: 14300, inputTokens: 10100, outputTokens: 4200, total: 59 },
  { date: "Jun 14", messages: 7, tokens: 9100, inputTokens: 6200, outputTokens: 2900, total: 38 },
  { date: "Jun 15", messages: 6, tokens: 7800, inputTokens: 5400, outputTokens: 2400, total: 32 },
];

export const hourlyActivity = [
  { hour: "12a", messages: 0 }, { hour: "1a", messages: 0 },
  { hour: "2a", messages: 1 }, { hour: "3a", messages: 0 },
  { hour: "4a", messages: 2 }, { hour: "5a", messages: 4 },
  { hour: "6a", messages: 7 }, { hour: "7a", messages: 12 },
  { hour: "8a", messages: 18 }, { hour: "9a", messages: 24 },
  { hour: "10a", messages: 22 }, { hour: "11a", messages: 19 },
  { hour: "12p", messages: 15 }, { hour: "1p", messages: 13 },
  { hour: "2p", messages: 17 }, { hour: "3p", messages: 21 },
  { hour: "4p", messages: 23 }, { hour: "5p", messages: 20 },
  { hour: "6p", messages: 16 }, { hour: "7p", messages: 11 },
  { hour: "8p", messages: 8 }, { hour: "9p", messages: 5 },
  { hour: "10p", messages: 3 }, { hour: "11p", messages: 1 },
];

export interface HourlyDaySnapshot {
  day: string;
  hours: number[];
}

export const weeklyHourlyActivity: HourlyDaySnapshot[] = [
  { day: "Mon", hours: [0,0,0,0,1,3,8,15,22,25,20,17,12,10,14,19,24,22,18,13,9,6,3,1] },
  { day: "Tue", hours: [0,0,1,0,2,4,9,17,24,27,23,19,14,11,15,20,26,23,19,14,10,7,4,1] },
  { day: "Wed", hours: [0,0,0,1,2,5,10,18,26,28,24,20,15,12,16,21,27,24,20,15,11,8,4,2] },
  { day: "Thu", hours: [0,1,0,0,3,6,11,19,27,30,25,21,16,13,17,22,28,25,21,16,12,9,5,2] },
  { day: "Fri", hours: [0,0,0,1,2,5,9,16,23,26,22,18,13,10,14,19,24,21,18,13,8,5,3,1] },
  { day: "Sat", hours: [0,0,0,0,1,2,5,10,15,18,16,14,11,9,12,15,17,14,10,7,5,3,1,0] },
  { day: "Sun", hours: [0,0,0,0,0,1,3,7,10,12,11,10,8,7,9,11,12,9,6,4,2,1,0,0] },
];

export const csvCategoryDistribution = [
  { name: "ملابس", value: 18 },
  { name: "أحذية", value: 12 },
  { name: "إكسسوارات", value: 8 },
  { name: "عطور", value: 5 },
  { name: "أخرى", value: 2 },
];